import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { setPerAddress, setStep, setTempAddress } from "../../../Reducer/customerSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";

const Address = (props) => {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const tempAddress = useSelector(state => state?.customer?.tempAddress)
    const perAddress = useSelector(state => state?.customer?.perAddress)
    const handleTempAddress = (e) => {
        dispatch(setTempAddress({ [e.target.name]: e.target.value }))
    }
    const handlePerAddress = (e) => {
        dispatch(setPerAddress({ [e.target.name]: e.target.value }))
    }
    const handleNext = async () => {
        if (tempAddress?.line1 || tempAddress?.line2 || tempAddress?.area || tempAddress?.city || tempAddress?.pincode || perAddress?.line1 || perAddress?.line2 || perAddress?.area || perAddress?.city || perAddress?.pincode) {
            if (!tempAddress?.line1) {
                toast.error("Communication Address Line 1 is required")
            } else if (!tempAddress?.line2) {
                toast.error("Communication Address Line 2 is required")
            } else if (!tempAddress?.area) {
                toast.error("Communication Address Area is required")
            } else if (!tempAddress?.city) {
                toast.error("Communication Address City is required")
            } else if (!validName?.test(tempAddress?.city)) {
                toast.error("Communication Address City is Invalid")
            } else if (!tempAddress?.pincode) {
                toast.error("Communication Address Pincode is required")
            } else if (tempAddress?.pincode?.length !== 6) {
                toast.error("Communication Address Pincode must be 6 number")
            } else if (!perAddress?.line1) {
                toast.error("Permanent Address Line 1 is required")
            } else if (!perAddress?.line2) {
                toast.error("Permanent Address Line 2 is required")
            } else if (!perAddress?.area) {
                toast.error("Permanent Address Area is required")
            } else if (!perAddress?.city) {
                toast.error("Permanent Address City is required")
            } else if (!validName.test(perAddress?.city)) {
                toast.error("Permanent Address City is Invalid")
            } else if (!perAddress?.pincode) {
                toast.error("Permanent Address Pincode is required")
            } else if (perAddress?.pincode?.length !== 6) {
                toast.error("Permanent Address Pincode must be 6 number")
            } else {
                let dataToBeSent = {
                    tempAddress: { ...tempAddress, state: tempAddress?.state ? tempAddress?.state : "tamilnadu", country: tempAddress?.country ? tempAddress?.country : "india" },
                    perAddress: { ...perAddress, state: perAddress?.state ? perAddress?.state : "tamilnadu", country: perAddress?.country ? perAddress?.country : "india" }
                }
                setLoading(true)
                const response = await Handler({ method: 'patch', url: `/customer/details/third/update/${props?.customerId}`, data: dataToBeSent })
                setLoading(false)
                if (response?.success) {
                    dispatch(setStep(3))
                } else {
                    toast.error(response?.message)
                }
            }
        } else {
            toast.error("Address not updated")
            dispatch(setStep(3))
        }
    }
    const setSteps = () => {
        dispatch(setStep(1))
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4">
                    <div className="form-label mb-3">Communication Address</div>
                    <div className="mb-3">
                        <label htmlFor="line1" className="form-label"> Line 1 </label>
                        <input autoComplete="off" disabled={loading} id="line1" type="text" name="line1" value={tempAddress?.line1 || ""} onChange={handleTempAddress} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="line2" className="form-label"> Line 2 </label>
                        <input autoComplete="off" disabled={loading} id="line2" type="text" name="line2" value={tempAddress?.line2 || ""} onChange={handleTempAddress} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="area" className="form-label"> Area </label>
                        <input autoComplete="off" disabled={loading} id="area" type="text" name="area" value={tempAddress?.area || ""} onChange={handleTempAddress} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label"> City </label>
                        <input autoComplete="off" disabled={loading} id="city" type="text" name="city" value={tempAddress?.city || ""} onChange={handleTempAddress} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label"> State </label>
                        <Select
                            value={tempAddress?.state ? { label: tempAddress?.state, value: tempAddress?.state } : { label: "TAMILNADU", value: "TAMILNADU" }}
                            onChange={(e) => handleTempAddress({ target: { value: e?.value, name: 'state' } })}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={[
                                { label: "ANDHRA PRADESH", value: "ANDHRA PRADESH" },
                                { label: "ARUNACHAL PRADESH", value: "ARUNACHAL PRADESH" },
                                { label: "ASSAM", value: "ASSAM" },
                                { label: "BIHAR", value: "BIHAR" },
                                { label: "CHANDIGARH", value: "CHANDIGARH" },
                                { label: "CHATTISGARH", value: "CHATTISGARH" },
                                { label: "DELHI", value: "DELHI" },
                                { label: "GOA", value: "GOA" },
                                { label: "GUJARAT", value: "GUJARAT" },
                                { label: "HARYANA", value: "HARYANA" },
                                { label: "HIMACHAL PRADESH", value: "HIMACHAL PRADESH" },
                                { label: "JAMMU AND KASHMIR", value: "JAMMU AND KASHMIR" },
                                { label: "JHARKHAND", value: "JHARKHAND" },
                                { label: "KARNATAKA", value: "KARNATAKA" },
                                { label: "KERELA", value: "KERELA" },
                                { label: "LADAKH", value: "LADAKH" },
                                { label: "MADHYA PRADESH", value: "MADHYA PRADESH" },
                                { label: "MAHARASTRA", value: "MAHARASTRA" },
                                { label: "MANIPUR", value: "MANIPUR" },
                                { label: "MEGHALAYA", value: "MEGHALAYA" },
                                { label: "MIZORAM", value: "MIZORAM" },
                                { label: "NAGALAND", value: "NAGALAND" },
                                { label: "ODISHA", value: "ODISHA" },
                                { label: "PUDUCHERRY", value: "PUDUCHERRY" },
                                { label: "PUNJAB", value: "PUNJAB" },
                                { label: "RAJASTHAN", value: "RAJASTHAN" },
                                { label: "SIKKIM", value: "SIKKIM" },
                                { label: "TAMILNADU", value: "TAMILNADU" },
                                { label: "TELANGANA", value: "TELANGANA" },
                                { label: "TRIPURA", value: "TRIPURA" },
                                { label: "UTTAR PRADESH", value: "UTTAR PRADESH" },
                                { label: "UTTARKHAND", value: "UTTARKHAND" },
                                { label: "WEST BENGAL", value: "WEST BENGAL" }
                            ]} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label"> Country </label>
                        <Select
                            value={tempAddress?.country ? { label: tempAddress?.country, value: tempAddress?.country } : { "value": "INDIA", "label": "INDIA" }}
                            onChange={(e) => handleTempAddress({ target: { value: e?.value, name: 'country' } })}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={[
                                {
                                    "value": "INDIA",
                                    "label": "INDIA"
                                }
                            ]} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="pincode" className="form-label"> Pincode </label>
                        <input autoComplete="off" maxLength={6} disabled={loading} id="pincode" type="text" name="pincode" value={tempAddress?.pincode || ""} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) handleTempAddress(e) }} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-4 align-items-center d-md-none d-flex">
                        <input type="checkbox" id="same" className="same" onChange={(e) => { if (e.target.checked) { dispatch(setPerAddress({ ...tempAddress })); } else { dispatch(setPerAddress({ line1: "", line2: "", area: "", city: "", pincode: "", country: "", state: "" })) } }} />
                        <label htmlFor="same" className="form-label ms-2 mb-0"> Same as Communication Address </label>
                    </div>
                </div>
                <div className="col-md-6 col-xl-4">
                    <div className="form-label mb-3">Permanent Address</div>
                    <div className="mb-3">
                        <label htmlFor="line1" className="form-label"> Line 1 </label>
                        <input autoComplete="off" disabled={loading} id="line1" type="text" name="line1" value={perAddress?.line1 || ""} onChange={(e) => handlePerAddress(e)} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="line2" className="form-label"> Line 2 </label>
                        <input autoComplete="off" disabled={loading} id="line2" type="text" name="line2" value={perAddress?.line2 || ""} onChange={(e) => handlePerAddress(e)} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="area" className="form-label"> Area </label>
                        <input autoComplete="off" disabled={loading} id="area" type="text" name="area" value={perAddress?.area || ""} onChange={(e) => handlePerAddress(e)} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label"> City </label>
                        <input autoComplete="off" disabled={loading} id="city" type="text" name="city" value={perAddress?.city || ""} onChange={(e) => handlePerAddress(e)} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label"> State </label>
                        <Select
                            value={perAddress?.state ? { label: perAddress?.state, value: perAddress?.state } : { label: "TAMILNADU", value: "TAMILNADU" }}
                            onChange={(e) => handlePerAddress({ target: { value: e?.value, name: 'state' } })}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={[
                                { label: "ANDHRA PRADESH", value: "ANDHRA PRADESH" },
                                { label: "ARUNACHAL PRADESH", value: "ARUNACHAL PRADESH" },
                                { label: "ASSAM", value: "ASSAM" },
                                { label: "BIHAR", value: "BIHAR" },
                                { label: "CHANDIGARH", value: "CHANDIGARH" },
                                { label: "CHATTISGARH", value: "CHATTISGARH" },
                                { label: "DELHI", value: "DELHI" },
                                { label: "GOA", value: "GOA" },
                                { label: "GUJARAT", value: "GUJARAT" },
                                { label: "HARYANA", value: "HARYANA" },
                                { label: "HIMACHAL PRADESH", value: "HIMACHAL PRADESH" },
                                { label: "JAMMU AND KASHMIR", value: "JAMMU AND KASHMIR" },
                                { label: "JHARKHAND", value: "JHARKHAND" },
                                { label: "KARNATAKA", value: "KARNATAKA" },
                                { label: "KERELA", value: "KERELA" },
                                { label: "LADAKH", value: "LADAKH" },
                                { label: "MADHYA PRADESH", value: "MADHYA PRADESH" },
                                { label: "MAHARASTRA", value: "MAHARASTRA" },
                                { label: "MANIPUR", value: "MANIPUR" },
                                { label: "MEGHALAYA", value: "MEGHALAYA" },
                                { label: "MIZORAM", value: "MIZORAM" },
                                { label: "NAGALAND", value: "NAGALAND" },
                                { label: "ODISHA", value: "ODISHA" },
                                { label: "PUDUCHERRY", value: "PUDUCHERRY" },
                                { label: "PUNJAB", value: "PUNJAB" },
                                { label: "RAJASTHAN", value: "RAJASTHAN" },
                                { label: "SIKKIM", value: "SIKKIM" },
                                { label: "TAMILNADU", value: "TAMILNADU" },
                                { label: "TELANGANA", value: "TELANGANA" },
                                { label: "TRIPURA", value: "TRIPURA" },
                                { label: "UTTAR PRADESH", value: "UTTAR PRADESH" },
                                { label: "UTTARKHAND", value: "UTTARKHAND" },
                                { label: "WEST BENGAL", value: "WEST BENGAL" }
                            ]} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label"> Country </label>
                        <Select
                            value={perAddress?.country ? { label: perAddress?.country, value: perAddress?.country } : { "value": "INDIA", "label": "INDIA" }}
                            onChange={(e) => handlePerAddress({ target: { value: e?.value, name: 'country' } })}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={[
                                {
                                    "value": "INDIA",
                                    "label": "INDIA"
                                }
                            ]} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="pincode" className="form-label"> Pincode </label>
                        <input autoComplete="off" maxLength={6} disabled={loading} id="pincode" type="text" name="pincode" value={perAddress?.pincode || ""} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) handlePerAddress(e) }} className="form-control input-theme text-uppercase" />
                    </div>
                    <div className="mb-3 align-items-center d-none d-md-flex">
                        <input type="checkbox" className="form-check-input" id="copy" name="copy" onChange={(e) => { if (e.target.checked) { dispatch(setPerAddress({ ...tempAddress })); } else { dispatch(setPerAddress({ line1: "", line2: "", area: "", city: "", pincode: "", country: "", state: "" })) } }} />
                        <label htmlFor="copy" className="form-label ms-2 mb-0"> Same as Communication Address </label>
                    </div>
                </div>
            </div>
            <NextPrev step={2} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Address;